import React, { createRef, useState } from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import { TabContext } from '@mui/lab'
import { Tab, Tabs, Tooltip } from '@mui/material'

import { Logger, LoggerTypes } from '../../../../../../utils'
import { Icon, iconNames, TabPanel } from '../../../../../../components'
import { FlowElementEndAboutPanel } from '../FlowElementEndAboutPanel'
import '../../../common-elements-style.scss'
import './style.scss'

/**
 * @returns {div}
 */
export const FlowElementEndTab = ({ currentProject, currentScenario, currentFlowGroup, currentElement }) => {
  const [tabValue, setTabValue] = useState(0)
  const { t } = useTranslation()
  const ref = createRef()

  const onTabChange = (e, newTabValue) => {
    Logger.trace(LoggerTypes.CONTROLLER, 'FlowElementEndTab.onTabChange()', { e, newTabValue })
    setTabValue(newTabValue)
  }

  Logger.trace(LoggerTypes.CONTAINER, 'FlowElementEndTab.render()', {
    tabValue,
    currentElement,
    currentProject,
    currentScenario,
    currentFlowGroup
  })

  return (
    <div className="FlowElementEndTab">
      <TabContext value={tabValue}>
        <Tabs value={tabValue} onChange={onTabChange}>
          <Tooltip ref={ref} title={t('flowActions.starts.tabs.about')}>
            <Tab disableRipple={true} id="simple-tab-0" icon={<Icon name={iconNames.VISION_SIMULATION} size={20} />} />
          </Tooltip>
        </Tabs>
        <TabPanel value={tabValue} index={0}>
          <FlowElementEndAboutPanel
            currentProject={currentProject}
            currentScenario={currentScenario}
            currentFlowGroup={currentFlowGroup}
          />
        </TabPanel>
      </TabContext>
    </div>
  )
}

FlowElementEndTab.displayName = 'FlowElementEndTab'

FlowElementEndTab.propTypes = {
  currentProject: PropTypes.object.isRequired,
  currentScenario: PropTypes.object.isRequired,
  currentFlowGroup: PropTypes.object.isRequired,
  currentElement: PropTypes.object
}

FlowElementEndTab.defaultProps = {
  currentProject: null,
  currentScenario: null,
  currentFlowGroup: null,
  currentElement: null
}
